module.exports = __webpack_public_path__ + "static/mobile-shifts-scheduling-app-c72bf3c729e62e4ee09556096ed72e04.png";